/* src/app/admin-setting/email/email-dialog/email-dialog.component.css */
.email-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px 16px;
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow-y: scroll;
  overflow-x: hidden;
}
.mat-form-field {
  width: 100%;
}
.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}
.mat-column-name {
  font-size: 12px;
  max-width: 150px;
  word-break: break-all;
}
.mat-column-actions {
  text-align: right;
}
mat-checkbox {
  margin-bottom: 8px;
}
@media (max-width: 600px) {
  .email-form {
    padding: 12px 4px;
    max-width: 100%;
  }
}
.email-form-field {
  margin-bottom: 8px;
}
.checkbox-group {
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
  align-items: center;
}
.email-checkbox {
  margin-bottom: 0;
}
.flex-div-parent {
  display: flex;
  flex-direction: row;
  gap: 8px;
  background-color: #f9f9f9;
  max-height: 800px !important;
}
.flex-div-child {
  flex-grow: 1;
}
.mail-content-preview {
  margin-top: 16px;
  padding: 16px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
::ng-deep .mat-mdc-form-field-subscript-wrapper,
.mat-mdc-form-field-bottom-align::before {
  height: 0px !important;
}
/*# sourceMappingURL=email-dialog.component.css.map */
